
/** DO NOT CHANGE OR RE-ARRANGE VALUES: they are stored in DB so only adding new values is recommended. */
export enum PremiumLevel {
    None = 0,
    Premium = 10,
}
